<template>
  <div class="pay-succ">
    <iconpark-icon name="circle-success" class="text-[40px]"></iconpark-icon>
    <div class="pay-succ__h1">{{ $t('zhi-fu-cheng-gong') }}</div>
    <div class="pay-succ__h2">{{ title }}</div>
    <div class="pay-succ__h3">{{ desc }}</div>
    <div v-if="showPullNewInfo" class="pay-succ__award">
      <div v-if="award.accept_total_credit_coins">
        {{
          $t(
            'nin-yi-wan-cheng-hao-you-zhu-li-jiang-li-nin-invitepropsawardaccepttotalcreditcoins-yan-bi',
            [award.accept_total_credit_coins],
          )
        }}
      </div>
      <div v-if="award.invitation_total_credit_coins">
        <span v-if="!award.accept_total_credit_coins">
          {{ $t('nin-yi-wan-cheng-hao-you-zhu-li') }}
        </span>
        {{
          $t('nin-de-hao-you-huo-de-invitepropsawardinvitationtotalcreditcoins-yan-bi', [
            award.invitation_total_credit_coins,
          ])
        }}
      </div>
      <div>
        {{ $t('kuai-lai-huo-qu-nin-de') }}
        <a @click="onClickInviteLink">
          {{ $t('zhuan-shu-yao-qing-lian-jie') }}
        </a>
        ，{{ $t('yao-qing-hao-you-gong-xiang-quan-yi-ba') }}
      </div>
    </div>
    <div class="pay-succ__h3">
      <span>{{ seconds }}s 后关闭页面</span>
      <span v-if="tip">，{{ tip }}</span>
    </div>
  </div>
</template>

<script setup lang="ts" name="PaySucc">
import { getInviteRecordInfo } from '@/api/module/marketing';
import { LOCAL_KEY } from '~/constants/config';
import { clearModals } from '~/hooks/useModal/modals/empty';

const props = defineProps<{
  title?: string;
  desc?: string;
  tip?: string;
}>();

const route = useRoute();

const payType = computed(() => route.query?.pay_type);
const isInviteUser = ref(false);
const award = ref({
  accept_total_credit_coins: 0,
  invitation_total_credit_coins: 0,
});
// 显示邀请信息
const showPullNewInfo = computed(
  () =>
    isInviteUser.value &&
    (award.value.accept_total_credit_coins || award.value.invitation_total_credit_coins),
);

const emits = defineEmits(['onSuccess']);

const timer: any = ref();
const seconds = ref(5);

const onClickInviteLink = () => {
  location.href = '/pull-new';
};

const getInviteInfo = async () => {
  getInviteRecordInfo({
    many: true,
    is_invitee: 0,
  }).then(res => {
    isInviteUser.value = res.data && res.data.length > 0 ? true : false;
    award.value = {
      accept_total_credit_coins: res.data?.[0]?.accept_total_credit_coins || 0,
      invitation_total_credit_coins: res.data?.[0]?.invitation_total_credit_coins || 0,
    };
  });
};

onMounted(async () => {
  await getInviteInfo();

  timer.value = setInterval(() => {
    if (seconds.value <= 0) {
      emits('onSuccess');
      clearInterval(timer.value);
      localSetItem(LOCAL_KEY.UPDATE_USERINFO, Date.now());
      if (payType.value) {
        window.close();
      } else {
        clearModals();
        location.reload();
      }
      return;
    }
    seconds.value--;
  }, 1000);
});
</script>

<style lang="scss" scoped>
.icon {
  color: var(--success-9);
}
.pay-succ {
  padding: 30px;
  min-height: 290px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  &__h1 {
    margin-top: 12px;
    font-size: 16px;
    font-weight: bold;
  }
  &__h3 {
    font-size: 14px;
    line-height: 20px;
    color: var(--warning-8);
  }
  &__h2 {
    font-size: 40px;
    font-weight: 400;
    color: var(--text-1);
  }
  &__award {
    font-size: 14px;
    line-height: 20px;
    color: #414751;
    text-align: center;
    padding: 24px 0 0;
    & > div {
      margin-bottom: 8px;
    }
    a {
      color: var(--purple-6);
      font-size: 14px;
    }
  }
}
</style>
